module.exports = __webpack_public_path__ + "static/media/cover-tunisia.553134b4.png";